<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-non-bodymatter element-type-toc" id="table-of-contents">
<div class="toc-heading"><h3 class="toc-title">Contents</h3></div>
<div class="toc-contents">
<div class="toc-frontmatter-group">
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-preface has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><a href="#/themilliondollarwritingseries"><span class="element-title-text">The Million Dollar Writing Series</span></a></p>
</div>
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-none has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><a href="#/introductionwalkingandtalking"><span class="element-title-text">Introduction: Walking and Talking</span></a></p>
</div>
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-none has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><a href="#/introductionitgetseasier"><span class="element-title-text">Introduction: It Gets Easier</span></a></p>
</div>
</div>
<div class="toc-bodymatter-group">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number">
<p class="element-title"><span class="element-number">1. </span><a href="#/chapter001"><span class="element-title-text">Talking to Myself—Why Dictate?</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number">
<p class="element-title"><span class="element-number">2. </span><a href="#/chapter002"><span class="element-title-text">“I Just Can’t Write That Way” and Other Myths</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number">
<p class="element-title"><span class="element-number">3. </span><a href="#/chapter003"><span class="element-title-text">Use Cases for Dictation</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number">
<p class="element-title"><span class="element-number">4. </span><a href="#/chapter004"><span class="element-title-text">Baby Steps—Getting Started with Dictation</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number">
<p class="element-title"><span class="element-number">5. </span><a href="#/chapter005"><span class="element-title-text">Dictating Finished Prose</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number">
<p class="element-title"><span class="element-number">6. </span><a href="#/chapter006"><span class="element-title-text">Dictating for Pantsers: The Instant Story Show</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number">
<p class="element-title"><span class="element-number">7. </span><a href="#/chapter007"><span class="element-title-text">Ride Along: Dictating While Driving</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number">
<p class="element-title"><span class="element-number">8. </span><a href="#/chapter008"><span class="element-title-text">Equipment for the Road</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number">
<p class="element-title"><span class="element-number">9. </span><a href="#/chapter009"><span class="element-title-text">Transcribing Your Dictation</span></a></p>
</div>
</div>
<div class="toc-backmatter-group">
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-afterword has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/afterword" title="Link target outside of Sample"><span class="element-title-text">Afterword</span></span></p>
</div>
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-none has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><a href="#/appendixstakebykevinjanderson"><span class="element-title-text">Appendix: STAKE by Kevin J. Anderson</span></a></p>
</div>
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-none has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><a href="#/disclaimerandcredits"><span class="element-title-text">Disclaimer and Credits</span></a></p>
</div>
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-about-author has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><a href="#/abouttheauthors"><span class="element-title-text">About the Authors</span></a></p>
</div>
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-none has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><a href="#/youmightalsoenjoy"><span class="element-title-text">You Might Also Enjoy</span></a></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?57797334